// extracted by mini-css-extract-plugin
export var statItem = "_c7-1";
export var statsRow = "_c7-0";